class NotificationFeed extends HTMLElement {
  constructor() {
    super();

    this.notificationAll = this.querySelectorAll('[data-notification]');
    this.openButtonAll = this.querySelectorAll('[data-open-button]');
    this.closeButtonAll = this.querySelectorAll('[data-close-button]');

    this.autoplayDelay = +(this.dataset.autoplayDelay);
    this.localStorageKeySuffix = this.dataset.localStorageKeySuffix;
    this.localStorageKey = `notification-feed--${this.localStorageKeySuffix}`;

    this.addEventListeners();
    this.setInitialState();

    if (this.classList.contains('is-medium')) {
      this.initAutoplay();
    }
  }

  addEventListeners() {
    this.openButtonAll.forEach((openButton) => {
      openButton.addEventListener('click', () => this.onClickOpenButton());
    });

    this.closeButtonAll.forEach((closeButton) => {
      closeButton.addEventListener('click', () => this.onClickCloseButton());
    });
  }

  onClickOpenButton() {
    if (this.classList.contains('is-medium')) {
      this.classList.remove('is-medium');
      this.classList.add('is-large');
      this.destroyAutoplay();
    } else {
      this.classList.remove('is-large');
      this.classList.add('is-medium');
      this.initAutoplay();
    }

    localStorage.setItem(this.localStorageKey, 'is-medium');
  }

  onClickCloseButton() {
    this.classList.remove('is-medium', 'is-large');
    this.destroyAutoplay();
    localStorage.setItem(this.localStorageKey, 'is-small');
  }

  setInitialState() {
    var state = localStorage.getItem(this.localStorageKey);

    if (!state || state != 'is-small') {
      localStorage.setItem(this.localStorageKey, 'is-medium');
      this.classList.remove('is-small');
      this.classList.add('is-medium');
    }
  }

  initAutoplay() {
    this.autoplayInterval = setInterval(() => {
      var notificationActive = [...this.notificationAll].find((notification) => {
        return notification.classList.contains('is-active');
      });

      var notificationNext = notificationActive.nextElementSibling || notificationActive.parentElement.firstElementChild;

      notificationActive.classList.remove('is-active');
      notificationNext.classList.add('is-active');
    }, this.autoplayDelay);
  }

  destroyAutoplay() {
    clearInterval(this.autoplayInterval);
  }
}

customElements.define('notification-feed', NotificationFeed);
